export default {"src":"/_next/static/media/ic-eye-slash.79ef24d2.svg","height":15,"width":17,"blurWidth":0,"blurHeight":0};